import { useContext } from 'react';
import { UserContext } from '../context/user-context';

function UserControlsComponent({ type }) {
  const { isUserLoggedIn, login, logout } = useContext(UserContext);

  const buttonClass =
    type === 'desktop'
      ? 'button button--primary-blue d-none d-lg-inline-block text-center'
      : 'button button--primary-blue d-block w-100 text-center';

  if (isUserLoggedIn()) {
    return (
      <button type="button" onClick={logout} className={buttonClass}>
        Logga Ut
      </button>
    );
  }

  return (
    <button type="button" className={buttonClass} onClick={login}>
      Logga In
    </button>
  );
}

export default UserControlsComponent;
